import { useDispatch } from 'react-redux'

import { User } from '@sentry/browser'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions as uiActions, selectors as uiSelectors } from 'builder/modules/ui'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import { AppConfig } from 'builder/modules/init'
import { useUser } from 'builder/hooks/useUser'

const MODAL_SHOWN_STORAGE_KEY = 'rd-auto-apply-dual-modal'

function isSupportedRegion(geoipCode: string | undefined) {
  return ['US', 'GB'].includes(geoipCode || '')
}

export function shouldShowAaRdModal(user: User | null, features: Partial<AppConfig['features']>) {
  const hasNotActivatedRD =
    user?.scopes?.resumeDistribution &&
    !['recurring', 'one_time'].includes(user?.scopes?.resumeDistributionCandidate || '')

  return (
    !localStorage.getItem('rd-auto-apply-dual-modal') &&
    !localStorage.getItem('auto-apply-upsell-modal') &&
    features.chAddons !== 'v1' &&
    user?.scopes?.autoApply &&
    ['/app', '/app/'].includes(window.location.pathname) &&
    isSupportedRegion(features.geoipCode) &&
    hasNotActivatedRD
  )
}

export const useAutoApplyResumeDistributionModal = () => {
  const dispatch = useDispatch()
  const payload = useTypedSelector(uiSelectors.isAutoApplyResumeDistributionModalPayload)
  const { features } = useFeaturesConfig()
  const user = useUser()
  const closeModal = () => {
    localStorage.setItem(MODAL_SHOWN_STORAGE_KEY, 'true')
    dispatch(uiActions.toggleAutoApplyResumeDistributionModal({ open: false }))
  }

  return {
    isOpen: shouldShowAaRdModal(user, features) && payload.open,
    label: payload.label,
    planName: '20_credits_autoapply',
    closeModal,
  }
}
